"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getTranslation", {
  enumerable: true,
  get: function get() {
    return _getTranslation["default"];
  }
});

var _getTranslation = _interopRequireDefault(require("./getTranslation"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}